import { APPLICATION_GROUP_BY, Route } from '@/core/entities/types/routes';
import { createRouteLoaderPageDetails } from '@/core/utils/routes.utils';
import Main from '@/core/views/main/main';
import History, {
  LEAD_INDICATION_PAGE_TITLE,
} from '@/modules/leadIndication/pages/history/history';
import ICONS from '@/shared/entities/constants/icons';

export enum ROUTE_LEAD_INDICATION {
  HISTORY = 'lead-indication-history',
}

const leadIndicationRoutes: Route[] = [
  {
    path: '/companies/:companyId/lead-indications',
    Component: Main,
    id: ROUTE_LEAD_INDICATION.HISTORY,
    meta: {
      groupedBy: APPLICATION_GROUP_BY.COMPANY,
      showApplicationMenu: true,
      icon: ICONS.LEAD_INDICATION,
      nameMenu: LEAD_INDICATION_PAGE_TITLE,
    },
    loader() {
      return createRouteLoaderPageDetails({
        title: LEAD_INDICATION_PAGE_TITLE,
      });
    },
    children: [
      {
        index: true,
        Component: History,
      },
    ],
  },
];

export default leadIndicationRoutes;
